import * as mobx from "mobx";
import reviewFiltersStore, { singleReviewFiltersStore } from "../../modules/reviews/ReviewFilterStore";
import SelectedLocationsStore from "../../services/locations/SelectedLocationsStore";
import { bindShallow } from "../../uiMigration/bindAngularWithMobx";

/**
 * 2 way binds review filters (reviewFiltersStore) state and the angular scope variable passed in.
 * Also one way binds the legacy group id from the SelectedLocationsStore to the angular scope variable as the field `groupId`.
 *
 * Angular scope is initialized immediately from reviewFiltersStore and SelectedLocationsStore
 * @param {*} $scope - angular scope from a controller
 * @param {*} scopeVariable - the variable that should get updates
 */
export function bindReviewFiltersAndSelectedLocationToAngular(
  $scope,
  scopeVariable
) {
  bindShallow($scope, scopeVariable, reviewFiltersStore.state, {
    initializeFromMobx: true,
    mobxToAngular: ({ groupId, ...rest }) => rest,
  });
  bindShallow($scope, scopeVariable, reviewFiltersStore.state, {
    initializeFromMobx: true,
  });
  $scope.$on(
    "$destroy",
    mobx.reaction(
      () => SelectedLocationsStore.legacyGroupIdOrAll,
      (groupId) => (scopeVariable.groupId = groupId),
      {
        fireImmediately: true,
      }
    )
  );
}

export function bindSingleReviewFiltersAndSelectedLocationToAngular(
  $scope,
  scopeVariable
) {
  bindShallow($scope, scopeVariable, singleReviewFiltersStore.state, {
    initializeFromMobx: true,
    mobxToAngular: ({ groupId, ...rest }) => rest,
  });
  bindShallow($scope, scopeVariable, singleReviewFiltersStore.state, {
    initializeFromMobx: true,
  });
  $scope.$on(
    "$destroy",
    mobx.reaction(
      () => SelectedLocationsStore.legacyGroupIdOrAll,
      (groupId) => (scopeVariable.groupId = groupId),
      {
        fireImmediately: true,
      }
    )
  );
}
